import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { authGuard } from '@p2p/auth/domain';

import { FallbackRoutingComponent } from './components/fallback-routing/fallback-routing.component';

const routes: Route[] = [
    {
        path: 'authorization',
        loadChildren: () => import('@p2p/auth/shell').then((m) => m.AuthShellModule)
    },
    {
        path: 'fallback',
        component: FallbackRoutingComponent,
        canActivate: [authGuard]
    },
    {
        path: 'users',
        loadChildren: () => import('@p2p/users/shell').then((m) => m.UsersShellModule),
        canActivate: [authGuard]
    },
    {
        path: 'dashboards',
        loadChildren: () => import('@p2p/dashboards/feature-dashboards').then((m) => m.FeatureDashboardsModule),
        canActivate: [authGuard]
    },
    {
        path: 'disputes',
        loadChildren: () => import('@p2p/disputes/feature-disputes').then((m) => m.DisputesFeatureDisputesModule),
        canActivate: [authGuard]
    },
    {
        path: 'platform-settings',
        loadChildren: () =>
            import('@p2p/platform-settings/feature-platform-settings').then((m) => m.FeaturePlatformSettingsModule),
        canActivate: [authGuard]
    },
    {
        path: 'payment',
        loadChildren: () => import('@p2p/payment/feature-profiles').then((m) => m.PaymentFeatureProfilesModule),
        canActivate: [authGuard]
    },
    {
        path: 'team',
        loadChildren: () => import('@p2p/team/feature-team').then((m) => m.TeamFeatureTeamModule),
        canActivate: [authGuard]
    },
    {
        path: 'api',
        loadChildren: () =>
            import('@p2p/api-management/feature-merch-api').then((m) => m.ApiManagementFeatureMerchApiModule),
        canActivate: [authGuard]
    },
    {
        path: 'notifications',
        loadChildren: () =>
            import('@p2p/notifications/feature-notifications').then((m) => m.NotificationsFeatureNotificationsModule),
        canActivate: [authGuard]
    },
    {
        path: '**',
        redirectTo: 'fallback'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { initialNavigation: 'enabledBlocking', useHash: true })],
    exports: [RouterModule]
})
export class AppRoutingModule {}
